var map = {
	"./1_HM.svg": 933,
	"./2_Obey.svg": 2,
	"./3_Shopify.svg": 158,
	"./4_Lacoste.svg": 559,
	"./5_Levis.svg": 248,
	"./6_Amazon.svg": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;